module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "ibox"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ibox-results-filters-collapse-box collapse in"
  }, [_c('div', {
    staticClass: "ibox-results-filters"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-lg-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Search")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "..."
    },
    on: {
      "input": _vm.updateKeywords
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("User Type")]), _vm._v(" "), _c('selectize', {
    staticClass: "form-control select2-material-placeholder",
    attrs: {
      "name": "type",
      "options": _vm.typeOptions
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Master Accounts")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.master),
      expression: "master"
    }],
    staticClass: "styled",
    attrs: {
      "id": "check-master",
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.master) ? _vm._i(_vm.master, null) > -1 : (_vm.master)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.master,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.master = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.master = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.master = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check-master"
    }
  }, [_vm._v("\n                  Yes\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-lg-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Show Archived")]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.archived),
      expression: "archived"
    }],
    staticClass: "styled",
    attrs: {
      "id": "check-archive",
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.archived) ? _vm._i(_vm.archived, null) > -1 : (_vm.archived)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.archived,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.archived = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.archived = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.archived = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "check-archive"
    }
  }, [_vm._v("\n                  Yes\n                ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ibox-content"
  }, [_c('ul', {
    staticClass: "list-detail list-detail-user"
  }, _vm._l((_vm.usersDecorated), function(user) {
    return _c('li', {
      key: 'users-' + user.id
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-5 col-lg-3"
    }, [_c('h2', {
      staticClass: "truncate"
    }, [_c('strong', [_vm._v(_vm._s(user.profile.full_name))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 col-lg-3"
    }, [_c('p', {
      staticClass: "truncate"
    }, [_c('i', {
      staticClass: "fa fa-at"
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": ("mailto:" + (user.email))
      }
    }, [_vm._v(_vm._s(user.email))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-lg-3"
    }, [_c('p', {
      staticClass: "truncate"
    }, [_c('i', {
      staticClass: "fa fa-phone"
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": ("tel:" + (user.mobile))
      }
    }, [_vm._v(_vm._s(user.mobile))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12 col-lg-3"
    }, [_c('div', {
      staticClass: "pull-right"
    }, [(user.active) ? _c('span', {
      staticClass: "status status-enabled"
    }, [_vm._v("Enabled")]) : _c('span', {
      staticClass: "status status-disabled"
    }, [_vm._v("Disabled")]), _vm._v(" "), (user.isClient) ? _c('router-link', {
      staticClass: "btn btn-circle btn-info",
      attrs: {
        "to": {
          name: 'users.overview',
          params: {
            id: user.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-building"
    })]) : _vm._e(), _vm._v(" "), (user.isCarrier) ? _c('router-link', {
      staticClass: "btn btn-circle btn-info",
      attrs: {
        "to": {
          name: 'users.overview',
          params: {
            id: user.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-truck"
    })]) : _vm._e(), _vm._v(" "), (user.isDriver) ? _c('router-link', {
      staticClass: "btn btn-circle btn-primary",
      attrs: {
        "to": {
          name: 'drivers.edit',
          params: {
            id: user.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user"
    })]) : _c('router-link', {
      staticClass: "btn btn-circle btn-primary",
      attrs: {
        "to": {
          name: 'users.edit',
          params: {
            id: user.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user"
    })])], 1)])]), _vm._v(" "), _c('ul', {
      staticClass: "details"
    }, [_c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!user.isDriver),
        expression: "!user.isDriver"
      }]
    }, [_c('span', [_vm._v("Company:")]), _vm._v(" " + _vm._s(user.profile.company_name) + ".")]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!user.isDriver),
        expression: "!user.isDriver"
      }]
    }, [_c('span', [_vm._v("Phone:")]), _vm._v(" " + _vm._s(user.profile.company_phone))]), _vm._v(" "), (!user.parent_id && !user.isDriver) ? _c('li', [_vm._v("MASTER")]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v(" ")])])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveNoUsers),
      expression: "haveNoUsers"
    }],
    staticClass: "text-center text-muted"
  }, [_c('strong', [_vm._v("There are no users.")])])]), _vm._v(" "), _c('lazy-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.haveUsers),
      expression: "haveUsers"
    }],
    ref: "lazyLoading",
    attrs: {
      "reached-bottom": _vm.getUsersForNextPage,
      "filters": _vm.filters
    }
  }, [_c('strong', {
    staticClass: "text-muted",
    slot: "finished"
  }, [_vm._v("There are no more users.")])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "ibox-results-collapse visible-xs",
    attrs: {
      "role": "button",
      "data-toggle": "collapse",
      "href": ".ibox-results-filters-collapse-box",
      "aria-expanded": "false",
      "aria-controls": "ibox-results-filters-collapse-box"
    }
  }, [_vm._v("\n      Show Filters "), _c('i', {
    staticClass: "fa fa-bars"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-e2e48374"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Users.vue
// module id = 1084
// module chunks = 0